import { Component, Input, OnInit } from "@angular/core";
import { MensajesService } from "../../services/mensajes/mensajes.service";
import { SafeHtml } from "@angular/platform-browser";

@Component({
  selector: "app-label-tooltip",
  templateUrl: "./label-tooltip.component.html",
  styleUrl: "./label-tooltip.component.css",
})
export class LabelTooltipComponent implements OnInit {
  @Input() for: string = "";
  @Input("titleLabel") title: string = "";
  @Input() isRequired: boolean = false;
  @Input() styleClass: string = "";
  @Input() etiqueta: string = "";

  visible: boolean = false;
  tooltipText: SafeHtml = "";
  isMobile: boolean;
  isTablet: boolean;
  isDesktopDevice: boolean;
  ismovil: boolean;

  showInfo() {
    this.visible = true;
  }

  constructor(private mensajesService: MensajesService) {
    let navegador = navigator.userAgent;
    if (
      navigator.userAgent.match(/Android/i) ||
      navigator.userAgent.match(/webOS/i) ||
      navigator.userAgent.match(/iPhone/i) ||
      navigator.userAgent.match(/iPad/i) ||
      navigator.userAgent.match(/iPod/i) ||
      navigator.userAgent.match(/BlackBerry/i) ||
      navigator.userAgent.match(/Windows Phone/i)
    ) {
      this.ismovil = true;
    } else {
      this.ismovil = false;
    }
  }

  ngOnInit(): void {
    this.tooltipText = this.mensajesService.getTooltipByEtiqueta(this.etiqueta);
    this.mensajesService.labelTextEmmiter.subscribe((response: boolean) => {
      if (response)
        this.tooltipText = this.mensajesService.getTooltipByEtiqueta(
          this.etiqueta
        );
    });
  }
}
